import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@mui/styles';
import { clsx } from 'clsx';

import { InfoTooltip } from '@components/InfoTooltip';

interface Props {
  title: string;
  tooltip?: NonNullable<React.ReactNode>;
  className?: string;
  fullWidth?: boolean;
  mt?: number;
}

export const InitialTitle = ({
  children, title, tooltip, className, fullWidth, mt,
}: PropsWithChildren<Props>) => {
  const cls = useStyles();

  return (
    <div style={{ marginTop: mt }} className={clsx(
      cls.box,
      className,
      fullWidth && cls.fullWidth,
    )}>
      {title && <div className={cls.title}>{title}</div>}
      {tooltip && <InfoTooltip title={tooltip} inline />}
      {children}
    </div>
  );
};

const useStyles = makeStyles({
  box: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '5px solid var(--primary-color)',
    borderRadius: 5,
    maxWidth: 300,
    fontSize: 18,
    fontWeight: 400,
    color: 'var(--text-color)',
    padding: '25px 30px 15px',

    '& .MuiInputLabel-standard': {
      display: 'none !important',
    },
  },
  fullWidth: {
    width: '100%',
    maxWidth: '100%',
  },
  title: {
    position: 'absolute',
    backgroundColor: 'var(--foreground-color)',
    top: -11,
    left: -5,
    paddingRight: 6,
  },
  value: {
    fontSize: 22,
  },
});
